import { COMMON_SPACING_SECTION, HEADER_HEIGHT_PX } from '@/constants'

// Timeline years data
const TIMELINE_YEARS = ['2019', '2020', '2021', '2022']

// Section data
const SECTIONS_DATA = [
  {
    id: 1,
    bgColor: '#252422',
    textColor: '#ffffff',
    layout: 'first',
  },
  {
    id: 2,
    bgColor: '#ffffff',
    textColor: '#252422',
    layout: 'second',
  },
  {
    id: 3,
    bgColor: '#252422',
    textColor: '#ffffff',
    layout: 'third',
  },
  {
    id: 4,
    bgColor: '#ffffff',
    textColor: '#252422',
    layout: 'fourth',
  },
]

const CommonStyles = {
  minWidth: '100vw',
  height: { xs: `calc(100vh - ${HEADER_HEIGHT_PX.BOTTOM_NAV.xs})`, md: '100vh' },
  py: COMMON_SPACING_SECTION,
  position: 'relative',
}

const SAMPLE_DATA_CONTENT = [
  {
    entity_id: 24,
    name: 'Áo Thun Hydra Basic 100% Coton 300GSM',
    key: 'ao-thun-basic-1',
    json: '{"type":"content_product","data":{"items":[{"section_3":{"items":[{"mode":"dark","image_url":"https://staging-api.themona.shop/media/product/g/r/group_2144772738_1__3.jpg"},{"mode":"light","image_url":"https://staging-api.themona.shop/media/product/g/r/group_2144772738_1__1.jpg"}]}},{"section_1":{"title":"Hydra không bán đồ dỏm, chúng tôi bán đồ xịn, giá tốt","items":[{"title":"Lựa chọn loại vải tốt nhất, hàm lượng cao nhất, giấy tờ chứng nhận đầy đủ.","image_url":"https://staging-api.themona.shop/media/product/f/r/frame_2144773669_37.png"},{"title":"Xưởng may lớn, uy tín, quy trình kiểm tra chất lượng nghiêm ngặt","image_url":"https://staging-api.themona.shop/media/product/f/r/frame_2144773669-1_3.png"},{"title":"Đóng gói kỹ càng, an toàn khi vận chuyển.","image_url":"https://staging-api.themona.shop/media/product/f/r/frame_2144773669-2_3.png"}]}},{"section_2":{"image_url":"https://staging-api.themona.shop/media/product/f/r/frame_2144773764_3.png","title":"Áo có độ hoàn thiện cao","description":"<p><strong>&Aacute;o Thun Hydra Basic 100% Cotton 300GSM</strong> của ch&uacute;ng t&ocirc;i được sản xuất ho&agrave;n to&agrave;n ở Việt Nam, với chất lượng tốt nhất,<strong> tho&aacute;ng m&aacute;t v&agrave; thấm h&uacute;t tốt.</strong><br><br><strong>Thiết kế đơn giản, dễ mặc, ph&ugrave; hợp với nhiều phong c&aacute;ch kh&aacute;c nhau, đi l&agrave;m, đi chơi đều hợp.</strong><br><br>Đường may tỉ mỉ, chắc chắn, kh&ocirc;ng bai x&ugrave;, kh&ocirc;ng phai m&agrave;u trong 100 lần giặt.</p>","commitment":[{"label":"Hàng chính hãng"},{"label":"Giấy tờ chứng nhận đầy đủ từ nhà cung cấp"}]}}]}}',
  },
]
const SAMPLE_DESCRIPTION_PRODUCT_MOBILE = [
  {
    entity_id: 31,
    name: 'Mô tả sản phẩm ở mobile',
    key: 'ao-thun-basic',
    json: '[{"title":"Hàm lượng cao nhất với 100% Cotton và 300GSM","desc":"<span style=\\"font-weight: 600;\\">Chất vải áo thun của Hydra</span> được sản xuất hoàn toàn ở Việt Nam với tiêu chuẩn cao nhất, bền bỉ, giặt nhiều lần vẫn không xuống màu, hư hại.","img":"/assets/images/product-sample/fake_desc1.png"},{"title":"LOGO in chuẩn màu","desc":"<span style=\\"font-weight: 600;\\">Logo được in nhiệt đảm bảo chuẩn màu như thiết kế.</span> Khó phai trong mọi tình trạng từ giặt tay hay máy giặt.","img":"/assets/images/product-sample/fake_desc2.png"},{"title":"Form áo cứng cáp","desc":"Sử dụng chất vải phù hợp với người Việt Nam ở mọi nhu cầu: đi chơi, đi làm, mặc hằng ngày,... Đều co dãn và thấm hút tốt","img":"/assets/images/product-sample/fake_desc3.png"}]',
  },
]
const MAX_ITEMS_REVIEW = 5
export {
  TIMELINE_YEARS,
  SECTIONS_DATA,
  CommonStyles,
  SAMPLE_DATA_CONTENT,
  MAX_ITEMS_REVIEW,
  SAMPLE_DESCRIPTION_PRODUCT_MOBILE,
}
